export const tituloPrincipal = "Conexões ";

export const adicionarAparelho = 'Adicionar Aparelho'

export const nenhumAprelhoConectado = "Nenhum aparelho conectado...";



export const escolherIcone = 'Escolha o ícone:'

export const escolherCorDefundo = 'Escolha a cor de fundo:'

export const btnBluetooth = 'Clique no botão abaixo para procurar e conectar aparelhos Bluetooth próximos:';

export const procurarAparelhosBluetooth = 'Procurar Aparelhos Bluetooth'

export const adicicionarAparelhoManualmente = 'Adicionar Aparelho Manualmente';

export const esperaMenuBluetoothAbrir = 'Aguarde, a janela de seleção do navegador será aberta'



export const mensagemAparelhoDesativado = 'Desativado'

export const detalhesaparelhoAmpliados = 'Detalhes do Aparelho';

export const mensagemExcluirAparelho = "Remover este aparelho ?";



export const tempoAparelhoConectado =  'Conectado desde:';

export const duracaoConecxao = 'Duração da Conexão:';

export const btnEditar = 'Editar Aparelho';

export const btnRemover = 'Remover Aparelho';